module.exports = __webpack_public_path__ + "img/eyyb-t2.86e298a6.jpg";